
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class PsPromoAvShopDialog extends Serenity.EntityDialog<PsPromoAvShopRow, any> {
        protected getFormKey() { return PsPromoAvShopForm.formKey; }
        protected getIdProperty() { return PsPromoAvShopRow.idProperty; }
        protected getLocalTextPrefix() { return PsPromoAvShopRow.localTextPrefix; }
        protected getNameProperty() { return PsPromoAvShopRow.nameProperty; }
        protected getService() { return PsPromoAvShopService.baseUrl; }
        protected getDeletePermission() { return PsPromoAvShopRow.deletePermission; }
        protected getInsertPermission() { return PsPromoAvShopRow.insertPermission; }
        protected getUpdatePermission() { return PsPromoAvShopRow.updatePermission; }

        protected form = new PsPromoAvShopForm(this.idPrefix);

    }
}